import { getJSON } from "@/lib/api"
import type { Story, StoryGeneration } from "@yomimono/types"

export type { StoryGeneration }

// Admin reader view of any story. Quiz is intentionally not fetched.
export const getAdminStory = (id: string) =>
  getJSON<Omit<Story, "quiz" | "quizResult">>(`/v1/admin/stories/${id}`)

// Admin-only generation telemetry for a story.
export const getStoryGeneration = (id: string) =>
  getJSON<StoryGeneration>(`/v1/admin/stories/${id}/generation`)
